const defaultState = {
  active: null
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_ACTIVE_FLOW_CONFIG':
      return Object.assign({}, state, {
        active: action.flowConfig
      })
    default:
      return state
  }
}
